import AdminLayout from '../../../components/AdminLayout'
import { ExhibitionForm } from '../../../components/ExhibitionForm'
import { withUser } from '../../../components/withUser'

const NewExhibition: React.FC = () => (
  <AdminLayout>
    <ExhibitionForm />
  </AdminLayout>
)

export default withUser(NewExhibition)
